import { EditText } from '../../../../../component/ui/edit-text/edit-text';
import { Button } from 'primereact/button';
import React, { useState } from 'react';
import { EditNumber } from '../../../../../component/ui/edit-text/edit-number';
import { createNewExamOperation } from './operations/create-new-exam-operation';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { ExamType } from '../../../../../api/types/settings/studies/exam-type';

interface AddNewExamDialogDatamodel {
  onHide: () => any;
  programId: number | undefined;
  courseId: number | undefined;
  isAlreadyHundredCompletionGradeTaken: boolean;
}
export const AddNewExamDialog: React.FC<AddNewExamDialogDatamodel> = ({
  onHide,
  programId,
  courseId,
  isAlreadyHundredCompletionGradeTaken,
}) => {
  const [name, setName] = useState('');
  const [completionGrade, setCompletionGrade] = useState(
    !isAlreadyHundredCompletionGradeTaken,
  );
  const [points, setPoints] = useState(0);
  const [selectedCity, setSelectedCity] = useState<ExamType>();

  const handleCreateNewExam = async () => {
    await createNewExamOperation(
      programId,
      courseId,
      name,
      selectedCity?.id,
      completionGrade,
      points,
      onHide,
    );
  };

  const examTypes = globalSettingsStores.examTypes;

  return (
    <div>
      <EditText title={'שם המבחן'} onChange={setName} />

      <label>סוג מבחן</label>
      <Dropdown
        value={selectedCity}
        onChange={(e) => setSelectedCity(e.value)}
        style={{
          height: '35px',
          width: '100%',
          alignItems: 'center',
          marginBottom: '16px',
        }}
        options={examTypes}
        optionLabel="examTypeName"
        placeholder="בחר סוג מבחן"
        className="w-full md:w-14rem"
      />

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <label>משלים למאה</label>
        <InputSwitch
          disabled={isAlreadyHundredCompletionGradeTaken}
          tooltip={
            isAlreadyHundredCompletionGradeTaken
              ? 'לא ניתן יותר ממבחן אחד משלים למאה בקורס'
              : 'המבחן בקורס ישלים למאה אחוז'
          }
          tooltipOptions={{
            showOnDisabled: true, // Only show tooltip when component is disabled
          }}
          checked={completionGrade}
          onChange={(e) => setCompletionGrade(e.value)}
        />
      </div>

      {!completionGrade && (
        <EditNumber
          onChange={setPoints}
          title={'אחוז מהציון הסופי'}
          min={0}
          max={100}
        />
      )}

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{
            height: '30px',
            marginTop: '24px',
          }}
          label={'אישור'}
          onClick={handleCreateNewExam}
        />
      </div>
    </div>
  );
};
